import { FormApi } from 'final-form'
import { VisibilidadeLembreteEnum } from 'graphql/types.generated'
import React from 'react'

import { LembreteForm, LembreteFormModel } from './components/LembreteForm'

interface AdicionarLembretesFormProps {
  onSubmit(values: LembreteFormModel, formApi: FormApi)
  onCancel?()
}

export function AdicionarLembreteForm(props: AdicionarLembretesFormProps) {
  const { onSubmit, onCancel } = props
  const handleSubmit = (lembrete: LembreteFormModel, formApi: FormApi) =>
    onSubmit({ ...lembrete, data: Date.now() }, formApi)
  return (
    <LembreteForm
      initialValues={{
        _id: null,
        ativo: true,
        descricao: '',
        visibilidadeLembrete: VisibilidadeLembreteEnum.PUBLICO,
      }}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      hasCancelButton
    />
  )
}
